/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define([], function() {
    'use strict';

    var MAX_VECTOR_ZOOM = 22;
    var MAX_RASTER_ZOOM = 20;

    return {
        /**
         * Updates the max zoom property based on given source name.
         * This method takes into account max zoom given in map.options property.
         * @method updateMaxZoom
         * @param {Map} map Map instance
         * @param {String} source one of 'vector' or 'raster'
         */
        updateMaxZoom: function(map, source) {
            var max;

            switch (source) {
            case 'raster': {
                max = MAX_RASTER_ZOOM;
                break;
            }
            case 'vector': {
                max = MAX_VECTOR_ZOOM;
                break;
            }
            default:
                return;
            }

            if (typeof map.options.maxZoom === 'undefined') {
                map._originalMaxZoom = Infinity;
            } else if (map._originalMaxZoom !== Infinity) {
                map._originalMaxZoom = map.options.maxZoom;
            }

            if (typeof map.options.maxZoom === 'number') {
                max = Math.min(max, map._originalMaxZoom);
            }

            map.setMaxZoom(max);
        }
    };
});



// WEBPACK FOOTER //
// ./display/utils.js